function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M232.4 154.7a10 10 0 00-10 10v189a10 10 0 0020 0v-189a10 10 0 00-10-10zm0 0M114.4 154.7a10 10 0 00-10 10v189a10 10 0 0020 0v-189a10 10 0 00-10-10zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.4 127.12V373.5c0 14.56 5.34 28.24 14.67 38.05A49.25 49.25 0 0078.8 427H268a49.23 49.23 0 0035.73-15.45c9.33-9.81 14.67-23.49 14.67-38.05V127.12A38.2 38.2 0 00308.6 52h-51.2V39.5A39.29 39.29 0 00217.8 0H129a39.29 39.29 0 00-39.6 39.5V52H38.2a38.2 38.2 0 00-9.8 75.12zM268 407H78.8c-17.1 0-30.4-14.69-30.4-33.5V128h250v245.5c0 18.81-13.3 33.5-30.4 33.5zM109.4 39.5A19.25 19.25 0 01129 20h88.8a19.26 19.26 0 0119.6 19.5V52h-128zM38.2 72h270.4a18 18 0 110 36H38.2a18 18 0 110-36zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M173.4 154.7a10 10 0 00-10 10v189a10 10 0 0020 0v-189a10 10 0 00-10-10zm0 0"
});

var SvgTrashCan = function SvgTrashCan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "#7D64E1",
    viewBox: "-40 0 427 427",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrashCan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trashCan.68931b1a.svg";
export { ForwardRef as ReactComponent };